import { Component, type OnChanges, type OnInit, inject } from '@angular/core';
import { AuthService } from '@infra/auth/auth.service';

@Component({
  selector: 'app-callback',
  template: ` <p>Loading...</p> `,
  styles: [],
  standalone: true,
})
export class CallbackComponent implements OnInit, OnChanges {
  private readonly authService = inject(AuthService);

  ngOnChanges(): void {
    this.authService.handleAuth();
  }

  ngOnInit(): void {
    this.authService.handleAuth();
  }
}
